module.exports = __webpack_public_path__ + "static/big-bed-in-a-bedroom-P8ZDEST-162b3a22abdbdd59c27647c8f07f660f.jpg";